
export default function Projects() {
  const projects = [
    {
      title: 'Reforma Integral Vivienda',
      category: 'Reforma',
      image: 'https://public.readdy.ai/ai/img_res/d684664f9151963420a1665eb797ea44.jpg'
    },
    {
      title: 'Construcción Chalet',
      category: 'Construcción',
      image: 'https://readdy.ai/api/search-image?query=Newly%20built%20modern%20villa%20or%20chalet%20exterior%2C%20contemporary%20residential%20architecture%2C%20clean%20lines%2C%20large%20windows%2C%20landscaped%20garden%2C%20professional%20architectural%20photography%20showing%20completed%20construction%20project%20with%20quality%20finishes%20and%20design&width=800&height=600&seq=project-chalet&orientation=landscape'
    },
    {
      title: 'Reforma Baño Completo',
      category: 'Reforma',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20renovated%20bathroom%20interior%20with%20modern%20fixtures%2C%20elegant%20tiles%2C%20walk-in%20shower%2C%20contemporary%20vanity%2C%20ambient%20lighting%2C%20professional%20interior%20photography%20showcasing%20complete%20bathroom%20renovation%20with%20attention%20to%20detail%20and%20quality%20materials&width=800&height=600&seq=project-bano&orientation=landscape'
    },
    {
      title: 'Rehabilitación Fachada',
      category: 'Rehabilitación',
      image: 'https://readdy.ai/api/search-image?query=Building%20facade%20rehabilitation%20and%20restoration%20work%2C%20renovated%20exterior%20walls%20with%20fresh%20paint%20or%20cladding%2C%20scaffolding%2C%20professional%20construction%20photography%20showing%20quality%20facade%20renovation%20and%20building%20conservation%20work&width=800&height=600&seq=project-fachada&orientation=landscape'
    }
  ];

  return (
    <section id="proyectos" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Proyectos Realizados
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block px-3 py-1 bg-teal-600 text-xs font-medium rounded-full mb-2">
                  {project.category}
                </span>
                <h3 className="text-xl font-bold">{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
